export default "__VITE_ASSET__OF249uC8__"